import { computed } from 'vue';
import { LoadingStatuses, LoadingTypes } from '@/models/loading.interface';
import campaignPresenter from '@/presenters/campaign-presenter';
import store from '@/store';

export default class LoadingWrapperCode {
	// Note: when introducing new loading types, make sure that all the functions with switch cases are updated accordingly.

	public hasLoadingFailed = computed((): boolean => {
		let status = LoadingStatuses.INACTIVE;
		switch (this.loadingType) {
			case LoadingTypes.ACCOUNT_MANAGER:
				status = this.loadingStatusAccountManagers.value;
				break;
			case LoadingTypes.CLIENT_SERVICES_PEOPLE:
				status = this.loadingStatusClientServicesPeople.value;
				break;
		}

		return status === LoadingStatuses.FAILURE;
	});

	public errorMessage = computed((): string => {
		switch (this.loadingType) {
			case LoadingTypes.ACCOUNT_MANAGER:
				return 'The account manager dropdown could not be populated due to a technical error.';
			case LoadingTypes.CLIENT_SERVICES_PEOPLE:
				return 'The client services dropdown could not be populated due to a technical error.';
			default:
				return 'This field could not be loaded due to a technical error.';
		}
	});

	private loadingStatusAccountManagers = computed((): LoadingStatuses => {
		return store.getters.loadingStatusAccountManagers();
	});

	private loadingStatusClientServicesPeople = computed((): LoadingStatuses => {
		return store.getters.loadingStatusClientServicesPeople();
	});

	constructor(
		private loadingType: LoadingTypes
	) { }

	public async retryLoadingProcess(): Promise<void> {
		switch (this.loadingType) {
			case LoadingTypes.ACCOUNT_MANAGER:
				await campaignPresenter.prepareAccountManagers();
				return;
			case LoadingTypes.CLIENT_SERVICES_PEOPLE:
				await campaignPresenter.prepareClientServicesPeople();
				return;
		}
	}
}
